import { Constants as WorkerConstants } from '../../../common/fuse/fuseSearch.constants.js';

export const Constants = {
  TAG_NAME: 'pop-pc-search-bar',
  TRANSLATION_KEYS: {
    SEARCH: 'search.search',
    SEARCH_PLACEHOLDER: 'search.search_placeholder',
    SEARCHBAR_PLACEHOLDER_TEXT: 'search.searchbar_placeholder_text',
    ERROR_MESSAGE: 'search.error_message',
    CLEAR_SEARCH: 'search.clear_search_input',
  },
  ICON_SLOT: 'icon',
  ATTRIBUTES: {
    SEARCH_FIELD_ID: '#pop-search-field-trigger',
    VALUE: 'value',
    PLACEHOLDER: 'placeholder',
    SEARCH_RESULTS_LIST_ID: '#pop-search-results-list',
    SEARCH_RESULT_NAME: 'pop-search-result',
  },
  EVENTS: {
    CLICK: 'click',
    KEYDOWN: {
      SPACE: 'Space',
      ENTER: 'Enter',
    },
  },
  SEARCH_MIN_LENGTH: 3,
  FUSE: {
    MIN_LENGTH: 3,
    MESSAGE_TYPES: {
      FUND_DATA: WorkerConstants.MessageType.FUND_DATA,
      SEARCH_TERM: WorkerConstants.MessageType.SEARCH_TERM,
    },
  },
};
